var _rect, _rect2, _circle, _rect3, _rect4, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHotspotSensitivity = function SvgHotspotSensitivity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.492,
    height: 1.167,
    x: 12.902,
    y: 8.166,
    fill: "#000",
    rx: 0.584
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.919,
    height: 1.167,
    x: 5.395,
    y: 8.166,
    fill: "#000",
    rx: 0.584
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.919,
    cy: 2.919,
    r: 2.419,
    stroke: "#000",
    transform: "matrix(-1 0 0 1 13.566 5.832)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.492,
    height: 1.167,
    fill: "#000",
    rx: 0.584,
    transform: "matrix(-1 0 0 1 11.887 15.004)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.919,
    height: 1.167,
    fill: "#000",
    rx: 0.584,
    transform: "matrix(-1 0 0 1 19.395 15.004)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.141,
    cy: 15.588,
    r: 2.419,
    stroke: "#000"
  })));
};
export default SvgHotspotSensitivity;